// extracted by mini-css-extract-plugin
export default {"body":"simple_body__ovUYK","foralign":"simple_foralign__vW-qj","btn-group-lg":"simple_btn-group-lg__vpg+7","btn":"simple_btn__1k-K4","btn-lg":"simple_btn-lg__69o1T"};